function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

const ROOTS = {
  AUTH: '/auth',
  DASHBOARD: '/center-app',
  CALENDAR: '/center-app/calendar',
  REPORT: '/center-app/report',
  LEARNING_PATHS: '/center-app/learning-paths',
  EMPLOYEES: '/center-app/employees',
  TEACHERS: '/center-app/teachers',
  CLASSES: '/center-app/classes',
  COURSES: '/center-app/courses',
  SESSIONS: '/center-app/sessions',
  ASSIGNMENTS: '/center-app/assignments',
  EXAMS: '/center-app/exams',
  STUDENTS: '/center-app/students',
  ORDERS: '/center-app/orders',
  FINANCE: '/center-app/finance',
  STUDENT_ABSENCE: '/center-app/students/student-absence',
  STUDENT_ABSENT: '/center-app/attendance_student_sessions',
  TEACHER_ABSENCE: '/center-app/teacher-absence',
  PRODUCT_EXPORT_SUMMARY: '/center-app/product-export-summaries',
  PRODUCT_IMPORT: '/center-app/product-import-summaries',
  PRODUCTS: '/center-app/products',
  SUPPLIERS: '/center-app/suppliers',
  DISCOUNTS: '/center-app/discounts',
  VOUCHERS: '/center-app/vouchers',
  PRICE_DISCOUNT_PROGRAM: '/center-app/price-discount-programs',
  PARTNERS: '/center-app/partners',
  ELEARNING: '/center-app/elearning',
  INCOMES: '/center-app/incomes',
  EXPENSES: '/center-app/expenses',
  CENTER_TRANSACTIONS: '/center-app/center-transactions',
  CENTER_COIN_TRANSACTIONS: '/center-app/center-transactions/coins',
  CONTACT_INFOS: '/center-app/contact-infos',
  CALL_CENTERS: '/center-app/call-centers',
  CENTER_TASKS: '/center-app/center-tasks',
  SETTING: '/center-app/setting',
  SETTING_CENTER_FEATURE: '/center-app/setting-center-feature',
  TUITION_FEE_BALANCE: '/center-app/tuition-fee-balance',
  CRITERIA_SCORE: '/center-app/criteria-score',
  REVIEWS: '/center-app/reviews',
  ACCOUNT: '/center-app/account',
  OTHER: '/center-app/other',
  INTERGRATION: '/center-app/integration',
  ZALO: '/center-app/zalo',
  // faqs
  CENTER_TOPIC_FAQS: '/faqs/center-topic-faqs',
  CENTER_SUB_TOPIC_FAQS: '/faqs/center-sub-topic-faqs',
  CENTER_FAQS: '/faqs/center-faqs',
  FAQS: '/faqs',
  BLOGS: '/blog',
  POLICY: '/policy',
  SUB_PAGE: '/sub-page',
};

// ----------------------------------------------------------------------

export const paths = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  transaction: '/transaction',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page403: '/error/403',
  page404: '/error/404',
  page500: '/error/500',
  components: '/components',
  setting_center_feature: ROOTS.SETTING_CENTER_FEATURE,

  policy: {
    refund: path(ROOTS.POLICY, '/refund'),
    privacy: path(ROOTS.POLICY, '/privacy'),
    term: path(ROOTS.POLICY, '/term'),
  },
  subPage: {
    manage: {
      hrm: path(ROOTS.SUB_PAGE, '/manage/quan-ly-nhan-su-trung-tam'),
      admission: path(ROOTS.SUB_PAGE, '/manage/quan-ly-tuyen-sinh'),
      student: path(ROOTS.SUB_PAGE, '/manage/quan-ly-hoc-vien'),
      financial: path(ROOTS.SUB_PAGE, '/manage/quan-ly-tai-chinh-trung-tam'),
      task: path(ROOTS.SUB_PAGE, '/manage/quan-ly-cong-viec'),
    },
    lms: {
      teacherManagement: path(ROOTS.SUB_PAGE, '/lms/quan-ly-giao-vien'),
      generateAssigment: path(ROOTS.SUB_PAGE, '/lms/tao-cau-hoi'),
      assignGradeAuto: path(ROOTS.SUB_PAGE, '/lms/phan-mem-giao-bai-tap'),
      quizOnline: path(ROOTS.SUB_PAGE, '/lms/trac-nghiem-online'),
    },
    operation: {
      sessionTracking: path(ROOTS.SUB_PAGE, '/operation/quan-ly-hoc-tap'),
      smartAttendance: path(ROOTS.SUB_PAGE, '/operation/diem-danh'),
      organizeClass: path(ROOTS.SUB_PAGE, '/operation/quan-ly-lop-hoc'),
      withdrawal: path(ROOTS.SUB_PAGE, '/operation/bao-luu-hoan-phi'),
      tuitionTracking: path(ROOTS.SUB_PAGE, '/operation/quan-ly-hoc-phi'),
    },
    smartPlatform: {
      communicationBook: path(ROOTS.SUB_PAGE, '/smart-platform/so-lien-lac-dien-tu-trung-tam'),
      zaloCrm: path(ROOTS.SUB_PAGE, '/smart-platform/tich-hop-zalo-ca-nhan-vao-crm'),
    },
  },

  report: {
    root: ROOTS.REPORT,
    dashboard: path(ROOTS.REPORT, `/dashboard-report`),
    crm: path(ROOTS.REPORT, `/crm-report`),
    task: path(ROOTS.REPORT, `/task-report`),
    sale: path(ROOTS.REPORT, `/sale-report`),
    cashFlow: path(ROOTS.REPORT, `/cash-flow-report`),
    pnl: path(ROOTS.REPORT, `/pnl-report`),
    student: {
      root: path(ROOTS.REPORT, `/student-report`),
      classEnroll: path(ROOTS.REPORT, `/student-report/class-enroll-report`),
      stopped: path(ROOTS.REPORT, `/student-report/stopped`),
    },
  },

  learningPaths: {
    root: ROOTS.LEARNING_PATHS,
  },

  // COURSE
  courses: {
    root: ROOTS.COURSES,
    create: path(ROOTS.COURSES, `/create`),
    detail: (courseId: string) => ({
      view: path(ROOTS.COURSES, `/${courseId}`),
      update: path(ROOTS.COURSES, `/${courseId}/update`),
      dashboard: path(ROOTS.COURSES, `/${courseId}`),
      info: path(ROOTS.COURSES, `/${courseId}/course-info`),
      classesCourses: {
        root: path(ROOTS.COURSES, `/${courseId}/course-classes`),
      },
      studentCourses: {
        root: path(ROOTS.COURSES, `/${courseId}/course-students`),
        detail: (studentId: string) => ({
          view: path(ROOTS.COURSES, `/${courseId}/course-students/${studentId}`),
          orders: path(ROOTS.COURSES, `/${courseId}/course-students/${studentId}/orders`),
          sessions: path(ROOTS.COURSES, `/${courseId}/course-students/${studentId}/sessions`),
          requests: path(ROOTS.COURSES, `/${courseId}/course-students/${studentId}/requests`),
          usedFee: path(ROOTS.COURSES, `/${courseId}/course-students/${studentId}/used-fee`),
          refunds: path(ROOTS.COURSES, `/${courseId}/course-students/${studentId}/refunds`),
          classReport: path(
            ROOTS.COURSES,
            `/${courseId}/course-students/${studentId}/class-report`
          ),
          review: path(ROOTS.COURSES, `/${courseId}/course-students/${studentId}/reviews`),
        }),
      },
      review: path(ROOTS.COURSES, `/${courseId}/course-reviews`),
      assignments: {
        root: path(ROOTS.COURSES, `/${courseId}/course-assignments`),
        detail: (assignmentId: string) => ({
          view: path(ROOTS.COURSES, `/${courseId}/course-assignments/${assignmentId}`),
        }),
      },
      settings: {
        root: path(ROOTS.COURSES, `/${courseId}/settings`),
        sessionCourseTemplates: {
          root: path(ROOTS.COURSES, `/${courseId}/settings/session-course-templates`),
          detail: (sessionCourseTemplateId: string) => ({
            view: path(
              ROOTS.COURSES,
              `/${courseId}/settings/session-course-templates/${sessionCourseTemplateId}`
            ),
            assignments: {
              root: path(
                ROOTS.COURSES,
                `/${courseId}/settings/session-course-templates/${sessionCourseTemplateId}/assignments`
              ),
              detail: (assignmentSessionCourseTemplateId: string) => ({
                view: path(
                  ROOTS.COURSES,
                  `/${courseId}/settings/session-course-templates/${sessionCourseTemplateId}/assignments/${assignmentSessionCourseTemplateId}`
                ),
              }),
            },
            documents: path(
              ROOTS.COURSES,
              `/${courseId}/settings/session-course-templates/${sessionCourseTemplateId}/documents`
            ),
          }),
        },

        assignmnetCourseTemplates: {
          view: path(ROOTS.COURSES, `/${courseId}/settings/assignmnet-course-templates`),
          detail: (assignmentCourseTemplateId: string) => ({
            view: path(
              ROOTS.COURSES,
              `/${courseId}/settings/assignmnet-course-templates/${assignmentCourseTemplateId}`
            ),
          }),
        },
        documentCourseTemplates: path(
          ROOTS.COURSES,
          `/${courseId}/settings/document-course-templates`
        ),
      },
    }),
  },

  // CLASSES
  classes: {
    root: ROOTS.CLASSES,
    create: path(ROOTS.CLASSES, `/create`),
    recruitment: path(ROOTS.CLASSES, `/recruitment`),
    teacherInvitationStatus: path(ROOTS.CLASSES, `/teacher-invitation-status`),
    detail: (classId: string) => ({
      view: path(ROOTS.CLASSES, `/${classId}`),
      update: path(ROOTS.CLASSES, `/${classId}/update`),
      dashboard: path(ROOTS.CLASSES, `/${classId}/dashboard`),
      reportAssignment: path(ROOTS.CLASSES, `/${classId}/report-assignment`),
      reportSession: path(ROOTS.CLASSES, `/${classId}/report-session`),
      general: path(ROOTS.CLASSES, `/${classId}/general`),
      chat: path(ROOTS.CLASSES, `/${classId}/chat`),
      // MEMBERS
      members: {
        root: path(ROOTS.CLASSES, `/${classId}/members`),
        detail: (memberId: string) => ({
          view: path(ROOTS.CLASSES, `/${classId}/members/${memberId}`),
          sessions: path(ROOTS.CLASSES, `/${classId}/members/${memberId}/sessions`),
          assignments: path(ROOTS.CLASSES, `/${classId}/members/${memberId}/assignments`),
          absences: path(ROOTS.CLASSES, `/${classId}/members/${memberId}/absences`),
          reviews: path(ROOTS.CLASSES, `/${classId}/members/${memberId}/reviews`),
          attendances: path(ROOTS.CLASSES, `/${classId}/members/${memberId}/attendances`),
        }),
      },

      // SESSIONS
      sessions: {
        root: path(ROOTS.CLASSES, `/${classId}/sessions`),
        detail: (sessionId: string) => ({
          view: path(ROOTS.CLASSES, `/${classId}/sessions/${sessionId}`),
          documents: path(ROOTS.CLASSES, `/${classId}/sessions/${sessionId}/documents`),
          assignments: {
            root: path(ROOTS.CLASSES, `/${classId}/sessions/${sessionId}/assignments`),
            detail: (assignmentId: string) => ({
              view: path(
                ROOTS.CLASSES,
                `/${classId}/sessions/${sessionId}/assignments/${assignmentId}`
              ),
            }),
            create: path(ROOTS.CLASSES, `/${classId}/sessions/${sessionId}/assignments/create`),
          },
          students: path(ROOTS.CLASSES, `/${classId}/sessions/${sessionId}/student-sessions`),
          teachers: path(ROOTS.CLASSES, `/${classId}/sessions/${sessionId}/teacher-sessions`),
          ratings: path(ROOTS.CLASSES, `/${classId}/sessions/${sessionId}/ratings`),
          tasks: path(ROOTS.CLASSES, `/${classId}/sessions/${sessionId}/tasks`),
        }),
      },

      // ASSIGNMENTS
      assignments: {
        root: path(ROOTS.CLASSES, `/${classId}/assignments`),
        create: path(ROOTS.CLASSES, `/${classId}/assignments/create`),
        detail: (assignmentId: string) => ({
          view: path(ROOTS.CLASSES, `/${classId}/assignments/${assignmentId}`),
        }),
      },

      // CENTER DOCUMENTS
      documents: {
        root: path(ROOTS.CLASSES, `/${classId}/center-documents`),
      },

      // TEACHER ENROLLS
      teacherEnrolls: {
        root: path(ROOTS.CLASSES, `/${classId}/teacher-enrolls`),
        create: path(ROOTS.CLASSES, `/${classId}/teacher-enrolls/create`),
        detail: (teacherEnrollId: string) => ({
          view: path(ROOTS.CLASSES, `/${classId}/teacher-enrolls/${teacherEnrollId}`),
        }),
      },

      // REVIEWS
      review: {
        root: path(ROOTS.CLASSES, `/${classId}/reviews`),
      },
    }),
  },

  // SESSIONS
  sessions: {
    root: ROOTS.SESSIONS,
    postponed: '/center-app/sessions/postponed-sessions',
  },

  // ASSIGNMENTS
  assignments: {
    root: ROOTS.ASSIGNMENTS,
    detail: (assignmentId: string) => ({
      view: path(ROOTS.CLASSES, `/${assignmentId}`),
    }),
  },

  exams: {
    root: ROOTS.EXAMS,
    detail: (examId: string) => ({
      view: path(ROOTS.EXAMS, `/${examId}`),
      assignments: {
        detail: (assignmentId: string) =>
          path(ROOTS.EXAMS, `/${examId}/assignments/${assignmentId}`),
      },
    }),
  },

  // STUDENT
  students: {
    root: ROOTS.STUDENTS,
    listCenterStudent: path(ROOTS.STUDENTS, `/list-center-student`),
    listStudentCourse: path(ROOTS.STUDENTS, `/list-student-course`),
    listLearningPathEnroll: path(ROOTS.STUDENTS, `/list-learning-path-enroll`),
    listClassEnroll: path(ROOTS.STUDENTS, `/list-class-enroll`),
    tuitionRenewals: path(ROOTS.STUDENTS, `/tuition-renewals`),
    listStudentSession: path(ROOTS.STUDENTS, `/list-student-session`),
    listMakeupStudentSession: path(ROOTS.STUDENTS, `/list-makeup-student-session`),
    listNewStudentSession: path(ROOTS.STUDENTS, `/list-new-student-session`),
    listStudentAssignment: path(ROOTS.STUDENTS, `/list-student-assignment`),
    absence: {
      root: path(ROOTS.STUDENTS, `/student-absence`),
      create: path(ROOTS.STUDENTS, `/student-absence/create`),
      detail: (absenceId: string) => ({
        view: path(ROOTS.STUDENTS, `/student-absence/${absenceId}`),
        update: path(ROOTS.STUDENTS, `/student-absence/${absenceId}/update`),
      }),
    },
    classTransfer: {
      root: path(ROOTS.STUDENTS, `/student-class-transfer`),
      create: path(ROOTS.STUDENTS, `/student-class-transfer/create`),
      detail: (transferId: string) => ({
        view: path(ROOTS.STUDENTS, `/student-class-transfer/${transferId}`),
        update: path(ROOTS.STUDENTS, `/student-class-transfer/${transferId}/update`),
      }),
    },
    retakeRequest: {
      root: path(ROOTS.STUDENTS, `/student-retake-request`),
    },
    refunds: {
      root: path(ROOTS.STUDENTS, `/refunds`),
      create: path(ROOTS.STUDENTS, `/refunds/create`),
      detail: (refundId: string) => ({
        view: path(ROOTS.STUDENTS, `/refunds/${refundId}`),
      }),
    },
  },

  tuitionFeeBalance: {
    root: ROOTS.TUITION_FEE_BALANCE,
  },

  criteriaScore: {
    root: ROOTS.CRITERIA_SCORE,
    create: path(ROOTS.CRITERIA_SCORE, `/create`),
    detail: (criteriaScoreId: string) => ({
      view: path(ROOTS.CRITERIA_SCORE, `/${criteriaScoreId}`),
      update: path(ROOTS.CRITERIA_SCORE, `/${criteriaScoreId}/update`),
    }),
  },

  // ORDER

  finance: {
    root: ROOTS.FINANCE,
    orders: {
      root: path(ROOTS.FINANCE, `/orders`),
      create: path(ROOTS.FINANCE, `/orders/create`),
      detail: (orderId: string) => ({
        view: path(ROOTS.FINANCE, `/orders/${orderId}`),
        update: path(ROOTS.FINANCE, `/orders/${orderId}/update`),
      }),
    },
    // PRODUCT IMPORT
    productImports: {
      root: path(ROOTS.FINANCE, `/product-import-summaries`),
      create: path(ROOTS.FINANCE, `/product-import-summaries/create`),
      detail: (productImportId: string) => ({
        view: path(ROOTS.FINANCE, `/product-import-summaries/${productImportId}`),
        update: path(ROOTS.FINANCE, `/product-import-summaries/${productImportId}/update`),
      }),
    },

    // INCOME
    incomes: {
      root: path(ROOTS.FINANCE, `/incomes`),
      create: path(ROOTS.FINANCE, `/incomes/create`),
      detail: (incomeSummaryId: string) => ({
        view: path(ROOTS.FINANCE, `/incomes/${incomeSummaryId}`),
        update: path(ROOTS.FINANCE, `/incomes/${incomeSummaryId}/update`),
      }),
    },

    // EXPENSE
    expenses: {
      root: path(ROOTS.FINANCE, `/expenses`),
      create: path(ROOTS.FINANCE, `/expenses/create`),
      detail: (expenseSummaryId: string) => ({
        view: path(ROOTS.FINANCE, `/expenses/${expenseSummaryId}`),
        update: path(ROOTS.FINANCE, `/expenses/${expenseSummaryId}/update`),
      }),
    },

    // TRANSACTION
    antTransactions: {
      root: path(ROOTS.FINANCE, `/center-transactions`),
      detail: (transactionId: string) => ({
        view: path(ROOTS.FINANCE, `/center-transactions/${transactionId}`),
      }),
    },
    antCoinTransactions: {
      root: path(ROOTS.FINANCE, `/center-transactions/coins`),
    },
    studentBalanceTransfers: {
      root: path(ROOTS.FINANCE, `/student-balance-transfers`),
    },
  },

  // OTHER
  others: {
    root: ROOTS.OTHER,
    products: {
      root: path(ROOTS.OTHER, '/products'),
      create: path(ROOTS.OTHER, `/products/create`),
      detail: (productId: string) => ({
        view: path(ROOTS.OTHER, `/products/${productId}`),
        update: path(ROOTS.OTHER, `/products/${productId}/update`),
      }),
    },
    partners: {
      root: path(ROOTS.OTHER, '/partners'),
      create: path(ROOTS.OTHER, `/partners/create`),
      detail: (partnerId: string) => ({
        view: path(ROOTS.OTHER, `/partners/${partnerId}`),
        update: path(ROOTS.OTHER, `/partners/${partnerId}/update`),
      }),
    },
  },
  // PRODUCT

  // SUPPLIER
  suppliers: {
    root: ROOTS.SUPPLIERS,
    create: path(ROOTS.SUPPLIERS, `/create`),
    detail: (supplierId: string) => ({
      view: path(ROOTS.SUPPLIERS, `/${supplierId}`),
      update: path(ROOTS.SUPPLIERS, `/${supplierId}/update`),
    }),
  },

  employees: {
    root: ROOTS.EMPLOYEES,
    create: path(ROOTS.EMPLOYEES, `/create`),
    detail: (employeeId: string) => ({
      view: path(ROOTS.EMPLOYEES, `/${employeeId}`),
      update: path(ROOTS.EMPLOYEES, `/${employeeId}/update`),
    }),
    role: path(ROOTS.EMPLOYEES, `/roles`),
    timesheet: path(ROOTS.EMPLOYEES, `/timesheet`),
    faceDetection: path(ROOTS.EMPLOYEES, `/face-detection`),
    teacherAbsence: {
      root: path(ROOTS.EMPLOYEES, `/teacher-absence`),
      create: path(ROOTS.EMPLOYEES, `/teacher-absence/create`),
      detail: (teacherAbsenceId: string) => ({
        view: path(ROOTS.EMPLOYEES, `/teacher-absence/${teacherAbsenceId}`),
        update: path(ROOTS.EMPLOYEES, `/teacher-absence/${teacherAbsenceId}/update`),
      }),
    },
  },

  teachers: {
    root: ROOTS.TEACHERS,
    create: path(ROOTS.TEACHERS, `/create`),
    classEnrolls: path(ROOTS.TEACHERS, `/class-enrolls`),
    detail: (teacherId: string) => ({
      view: path(ROOTS.TEACHERS, `/${teacherId}`),
      update: path(ROOTS.TEACHERS, `/${teacherId}/update`),
      teacherSchedule: {
        root: path(ROOTS.TEACHERS, `/${teacherId}/teacher-schedule`),
      },
      teacherClass: {
        root: path(ROOTS.TEACHERS, `/${teacherId}/teacher-class`),
      },
      workSheet: {
        root: path(ROOTS.TEACHERS, `/${teacherId}/work-sheet`),
      },
      teacherOutStanding: {
        root: path(ROOTS.TEACHERS, `/${teacherId}/teacher-out-standing`),
      },
    }),
    timesheet: path(ROOTS.TEACHERS, `/timesheet`),
  },

  // ELEARNING
  elearning: {
    root: ROOTS.ELEARNING,
    questionBanks: {
      root: path(ROOTS.ELEARNING, '/question-banks'),
      create: path(ROOTS.ELEARNING, '/question-banks/create'),
      detail: (id: string) => ({
        view: path(ROOTS.ELEARNING, `/question-banks/${id}`),
        update: path(ROOTS.ELEARNING, `/question-banks/${id}/update`),
      }),
    },

    assignmentBanks: {
      root: path(ROOTS.ELEARNING, '/assignment-banks'),
      detail: (id: string) => ({
        view: path(ROOTS.ELEARNING, `/assignment-banks/${id}`),
      }),
    },
  },

  zalo: {
    root: ROOTS.ZALO,
    thread: (zaloThreadId: string) => path(ROOTS.ZALO, `/${zaloThreadId}`),
  },

  // CONTACT INFO
  contactInfos: {
    root: ROOTS.CONTACT_INFOS,
    create: path(ROOTS.CONTACT_INFOS, `/create`),
    detail: (contactInfoId: string) => ({
      view: path(ROOTS.CONTACT_INFOS, `/${contactInfoId}`),
      update: path(ROOTS.CONTACT_INFOS, `/${contactInfoId}/update`),
    }),
    callHistories: path(ROOTS.CONTACT_INFOS, `/call-histories`),
    zaloThreads: {
      root: path(ROOTS.CONTACT_INFOS, `/zalo-threads`),
      thread: (zaloThreadId: string) => path(ROOTS.CONTACT_INFOS, `/zalo-threads/${zaloThreadId}`),
    },
    telecomBranchs: path(ROOTS.CONTACT_INFOS, `/telecom-branchs`),
    placementTestAppointments: path(ROOTS.CONTACT_INFOS, `/placement-test-appointments`),
    customerAppointments: path(ROOTS.CONTACT_INFOS, `/customer-appointments`),
    trialStudentSessions: path(ROOTS.CONTACT_INFOS, `/trial-student-sessions`),
    consultationReports: path(ROOTS.CONTACT_INFOS, `/consultation-reports`),
  },

  // SWITCH BOARD
  integration: {
    root: ROOTS.INTERGRATION,
    settingCallCenter: path(ROOTS.INTERGRATION, `/setting-call-center`),
    settingCenterApiKey: path(ROOTS.INTERGRATION, `/setting-center-api-key`),
    settingZaloAccount: path(ROOTS.INTERGRATION, `/setting-zalo-account`),
  },
  // SETTING
  setting: {
    root: ROOTS.SETTING,
    tagManagement: path(ROOTS.SETTING, `/tag-management`),
    settingCriteriaScore: path(ROOTS.SETTING, `/setting-criteria-score`),
    aiGradingProfiles: path(ROOTS.SETTING, `/ai-grading-profiles`),

    settingCenterFeature: path(ROOTS.SETTING, `/setting-center-feature`),
    settingNotification: path(ROOTS.SETTING, `/setting-notification`),
    settingApprovalWorkflow: path(ROOTS.SETTING, `/setting-approval-workflow`),
    settingCenterTask: {
      root: path(ROOTS.SETTING, `/setting-center-task`),
      customerStatus: path(ROOTS.SETTING, `/setting-center-task/task-status`),
      customerRegister: path(ROOTS.SETTING, `/setting-center-task/task-group`),
    },
    settingCenterCustomer: {
      root: path(ROOTS.SETTING, `/setting-center-customer`),
      customerStatus: path(ROOTS.SETTING, `/setting-center-customer/customer-status`),
      customerRegister: path(ROOTS.SETTING, `/setting-center-customer/customer-register`),
    },
    settingCenterRole: path(ROOTS.SETTING, `/setting-center-role`),
    settingCalendar: path(ROOTS.SETTING, `/setting-calendar-event`),
    settingClassRoom: path(ROOTS.SETTING, `/setting-class-room`),
    resourceAvailability: path(ROOTS.SETTING, `/resource-availability`),
    financialSetting: path(ROOTS.SETTING, `/financial-setting`),
    financialTemplates: {
      root: `${path(ROOTS.SETTING, `/financial-setting`)}?drawer=order-summary-templates`,
      create: `${path(ROOTS.SETTING, `/financial-setting`)}?drawer=order-summary-template-form`,
      edit: (templateId: string) =>
        `${path(ROOTS.SETTING, `/financial-setting`)}?drawer=order-summary-template-form&templateId=${encodeURIComponent(templateId)}`,
    },
    promotion: {
      root: path(ROOTS.SETTING, `/promotions`),
      discounts: {
        root: path(ROOTS.SETTING, `/promotions/discounts`),
        create: path(ROOTS.SETTING, `/promotions/discounts/create`),
        detail: (discountId: string) => ({
          view: path(ROOTS.SETTING, `/promotions/discounts/${discountId}`),
          update: path(ROOTS.SETTING, `/promotions/discounts/${discountId}/update`),
        }),
      },
      vouchers: {
        root: path(ROOTS.SETTING, `/promotions/vouchers`),
        create: path(ROOTS.SETTING, `/promotions/vouchers/create`),
        detail: (voucherId: string) => ({
          view: path(ROOTS.SETTING, `/promotions/vouchers/${voucherId}`),
          update: path(ROOTS.SETTING, `/promotions/vouchers/${voucherId}/update`),
        }),
      },

      priceDiscountPrograms: {
        root: path(ROOTS.SETTING, `/promotions/price-discount-programs`),
        create: path(ROOTS.SETTING, `/promotions/price-discount-programs/create`),
        detail: (priceDiscountProgramId: string) => ({
          view: path(
            ROOTS.SETTING,
            `/promotions/price-discount-programs/${priceDiscountProgramId}`
          ),
          update: path(
            ROOTS.SETTING,
            `/promotions/price-discount-programs/${priceDiscountProgramId}/update`
          ),
        }),
      },
    },
  },

  // CENTER TASK
  centerTasks: {
    root: ROOTS.CENTER_TASKS,
    create: path(ROOTS.CENTER_TASKS, `/create`),
    detail: (centerTaskId: string) => ({
      view: path(ROOTS.CENTER_TASKS, `/${centerTaskId}`),
      update: path(ROOTS.CENTER_TASKS, `/${centerTaskId}/update`),
    }),
  },

  blogs: {
    root: ROOTS.BLOGS,
    detail: (blogId: string) => ({
      view: path(ROOTS.BLOGS, `/${blogId}`),
    }),
  },

  // FAQS
  centerTopicFaqs: {
    root: ROOTS.CENTER_TOPIC_FAQS,
    detail: (topicFaqId: string) => ({
      view: path(ROOTS.CENTER_TOPIC_FAQS, `/${topicFaqId}`),
      subtopic: {
        root: path(ROOTS.CENTER_TOPIC_FAQS, `/${topicFaqId}/center-subtopic-faq`),
        detail: (subtopicId: string) => ({
          view: path(ROOTS.CENTER_TOPIC_FAQS, `/${topicFaqId}/center-subtopic-faq/${subtopicId}`),
          faq: {
            root: path(
              ROOTS.CENTER_TOPIC_FAQS,
              `/${topicFaqId}/center-subtopic-faq/${subtopicId}/center-faq`
            ),
            detail: (slug: string) => ({
              view: path(
                ROOTS.CENTER_TOPIC_FAQS,
                `/${topicFaqId}/center-subtopic-faq/${subtopicId}/center-faq/${slug}`
              ),
            }),
          },
        }),
      },
    }),
  },
  centerSubTopicFaqs: {
    root: ROOTS.CENTER_SUB_TOPIC_FAQS,
  },
  centerFaqs: {
    root: ROOTS.CENTER_FAQS,
  },
  listFaq: {
    root: ROOTS.FAQS,
    detail: (subTopicId: string) => ({
      view: path(ROOTS.FAQS, `/${subTopicId}`),
    }),
  },

  account: {
    task: path(ROOTS.ACCOUNT, `/tasks`),
    classes: path(ROOTS.ACCOUNT, `/classes`),
    calendar: path(ROOTS.ACCOUNT, `/calendar`),
    notification: path(ROOTS.ACCOUNT, `/notifications`),
    absence: path(ROOTS.ACCOUNT, `/absences`),
    customer: path(ROOTS.ACCOUNT, `/customers`),
    order: path(ROOTS.ACCOUNT, `/orders`),
    approval: path(ROOTS.ACCOUNT, `/approvals`),
  },

  // AUTH
  auth: {
    login: `/auth/login`,
  },
  // DASHBOARD
  dashboard: {
    root: ROOTS.DASHBOARD,
    calendar: ROOTS.CALENDAR,
  },

  reviews: {
    root: ROOTS.REVIEWS,
  },
};
